import { forEach } from "lodash";
import configs from "@/configs.json";

export const ENDPOINTS = {
  POST_LOGIN: "/auth/login",
  POST_REGISTER: "/auth/register",
  POST_REGISTER_PUBLIC: "/auth/registerPublic",
  GOOGLE_AUTH: "/auth/google",
  GOOGLE_AUTH_CALLBACK: "/auth/google/callback",
  ONE_AUTH: "/auth/:id",
  GET_CURRENT_USER: "/auth/profile",
  CREATE_MULTIPLE_USERS: "/auth/registerMultiple",
  GET_LIST_USER: "/auth/list",
  GET_LIST_ITEMS: "/items",
  CREATE_MULTIPLE_ITEMS: "/items/bulk",
  ONE_ITEM: "/items/:id",
  GENERATE_IDEAS: "/items/generateIdeas",
  GENERATE_GRAMMARS: "/items/generateGrammars",
  GENERATE_STRUCTURES: "/items/generateStructures",
  GET_PERCENTAGE_MATCHED_QUESTION: "/items/getPercentageMatchedQuestion/:id",
  GET_IDEA_GUIDANCE: "/items/idea-guidance/:id",
  GET_IDEA_GUIDANCE_ASPECTS: "/items/idea-guidance-aspects/:id",
  GET_QUESTIONS_GROUPED_BY_TOPIC: "/items/questions-grouped-by-topic",
  CUSTOM_ANSWER: "/answers",
  ONE_ITEM_CUSTOM_ANSWER: "/answers/:id",
  REMOVE_MULTIPLE_ITEMS: "/items/removeMultiples",
  GENERATE_CONNECTOR: "/answers/generate-connector",
  GET_QUOTA: "/answers/generate-connector/quota",
  GET_QUOTA_PRACTICE: "/practices/quota",
  REPHARSE_ANSWER: "/answers/repharse-answer",
  EDIT_INFO_USER: "/auth/profile/update",
  CHANGE_STATUS_USER: "/auth/change-status/:id",
  BULK_UPDATE_EXPIRED_TIME: "/auth/bulk-update-expired-time",
  POST_CHALLENGES_UPLOAD: "/challenges/upload",
  POST_CHALLENGES_TRANSCRIBE: "/challenges/:id/transcribe",
  POST_CHALLENGES_EVALUATE: "/challenges/:id/evaluate",
  POST_PRACTICES_UPLOAD: "/practices/upload",
  POST_PRACTICES_TRANSCRIBE: "/practices/:id/transcribe",
  POST_PRACTICES_EVALUATE: "/practices/:id/evaluate",
  POST_PRACTICES_SPEECHACE_EVALUATE: "/practices/:id/speechace-evaluate",
  POST_PRACTICES_SPEECHACE_AI_ANALYZE: "/practices/:id/speechace-ai-analyze",
  POST_PRACTICES_SUGGEST_IMPROVED_ANSWER: "/practices/:id/suggest-improved-answer",
  POST_PRACTICES_CHECK_QUESTION: "/practices/check-question",
  POST_WORD_MATCH_EVALUATE: "/practices/:id/word-match",
  GET_WORD_SEARCH: "/dicts/search",
  // word bank
  CREATE_WORDBOOK: "/wordbooks",
  GET_WORDBOOKS: "/wordbooks",
  DELETE_WORDBOOK: "/wordbooks/:id",
  EDIT_WORDBOOK: "/wordbooks/:id",
  GET_ONE_WORDBOOK: "/wordbooks/:id",
  GET_WORDBOOKS_GROUPED_BY_QUESTION: "/wordbooks/grouped-by-question",
  GET_GEN_ANSWER_WORDBOOKS_BY_QUESTION_IDS: "/wordbooks/gen-answer-by-question-ids",
  SAVE_WORD: "/vocabs",
  GET_VOCABS_BY_WORDBOOK: "/vocabs/wordbook/:wordbookId",
  DELETE_VOCAB: "/vocabs/:id",
  GENERATE_VOCABULARY_PRACTICE: "/vocabs/generatePractice",
  GET_MY_PRACTICE: "/practices/my-practice",
  // Dashboard endpoints
  GET_DASHBOARD_OVERVIEW: "/dashboard/overview",
  GET_DASHBOARD_STATS: "/dashboard/stats",
  GET_DASHBOARD_RECENT_ACTIVITIES: "/dashboard/recent-activities",
  GET_DASHBOARD_PROGRESS_CHART: "/dashboard/progress-chart",
  GET_DASHBOARD_RECOMMENDATIONS: "/dashboard/recommendations",
  GET_DASHBOARD_LEADERBOARD: "/dashboard/leaderboard",
  GET_DASHBOARD_GAME_REWARD_STATUS: "/dashboard/game-reward-status",
  POST_DASHBOARD_CLAIM_GAME_REWARD: "/dashboard/claim-game-reward",
  POST_GAME_SSO_TICKET: "/auth/game-sso-ticket",
  // Admin Dashboard endpoints
  GET_ADMIN_DASHBOARD_OVERVIEW: "/dashboard/admin/overview",
  GET_ADMIN_AI_CALL_STATS: "/dashboard/admin/ai-call-stats",
  GET_ADMIN_ACTIVITY_CHART: "/dashboard/admin/activity-chart",
  GET_ADMIN_SPEECHACE_BILLING: "/dashboard/admin/speechace-billing",
  GET_ADMIN_AI_BILLING: "/dashboard/admin/ai-billing",
  GET_LIST_AI_LOG: "/ai-log",
  UPLOAD_FILES: "/files/upload",
  SAVE_PERSONALIZED_CMS: "/files/savePersonalizedCMS",
  GET_PERSONALIZED_FILE: "/uploads/personalized.json",
  WORD_LIMIT_ANSWER: "/answers/word-limit-answer",
  GET_SUGGEST_VOCA_BY_BAND: "/answers/suggest-voca-by-band",
  BACKOFFICE_SAVE_BY_CODE: "/backoffice/:code",
  BACKOFFICE_GET_BY_CODE: "/backoffice/:code",
  GET_HELPS: "/helpers",
  GRAMMAR_ANALYSIS: "/answers/grammar-analysis",
  GET_GRAMMAR_BY_QUESTION: "/grammars/question/:questionId",
  GRAMMAR_GENERATE: "/grammars/generate",
  GRAMMAR_SAVE: "/grammars/createOrUpdate",
  GRAMMAR_ANALYZE_SENTENCE: "/grammars/analyzeGrammarSentence",
  GRAMMAR_GENERATE_PRACTICE: "/grammars/generateGrammarPractice",

  // Grammar Library / Books Endpoints
  GRAMMAR_BOOK_LIST: "/grammars/books",
  GRAMMAR_BOOK_DETAIL: "/grammars/books/:id",
  GRAMMAR_BOOK_CREATE: "/grammars/books",
  GRAMMAR_BOOK_UPDATE: "/grammars/books/:id",
  GRAMMAR_BOOK_DELETE: "/grammars/books/:id",
  GRAMMAR_BOOK_STUDENT_ACTIVE: "/grammars/books-student/active",
  GRAMMAR_BOOK_STUDENT_DETAIL: "/grammars/books-student/active/:slug",
  GRAMMAR_BOOK_STUDENT_PROGRESS: "/grammars/progress/book/:bookId",
  GRAMMAR_BOOK_STUDENT_SUBMIT_PROGRESS: "/grammars/progress/submit",

  ADD_INVOICE_ENERGY: "/energy-invoice/add",
  GRAMMAR_SAVED_ADD: "/grammar-saved",
  GRAMMAR_SAVED_LIST: "/grammar-saved",
  CLEANING_IDEAS: "/items/cleaningIdeas",
  GEN_DICT: "/dicts/gen",
  UPDATE_DICT: "/dicts/:id",
  GEN_GUIDED_QUESTIONS: "/items/genGuidedQuestions",
  GET_QUIDED_QUESTIONS: "/items/getGuidedByQuestion/:questionId",
  SUGGEST_ANSWER_GUIDED_QUESTION: "/items/suggestAnswerGuidedQuestion",
  SUGGEST_ANSWER_PART_TWO: "/items/suggestAnswerPartTwo",
  ADD_CONNECTOR_ANSWER_PART_TWO: "/items/addConnectorAnswerPartTwo",
  GENERATE_IDEAS_BY_ASPECTS: "/items/generateIdeasByAspects",
  DELETE_GUIDED_QUESTIONS: "/items/deleteGuidedQuestion",
  KEYWORD_TO_IDEA: "/items/keywordToIdea",
  KEYWORD_TO_IDEA_PART_2: "/items/keywordToIdeaPart2",
  // teacher
  // class module
  GET_CLASS_BY_TEACHER: "/class/by-teacher",
  GET_STUDENTS_BY_TEACHER: "/class/students/by-teacher",
  CREATE_CLASS: "/class/create",
  GET_ONE_CLASS: "/class/get-one/:classId",
  JOIN_CLASS: "/class/join",
  STUDENT_GET_LIST_MY_CLASS: "/class/student/my-class",
  STUDENT_LEAVE_CLASS: "/class/:classId/leave",
  ADD_STUDENTS_TO_CLASS: "/class/:classId/add-students-by-emails",
  REMOVE_STUDENT_FROM_CLASS: "/class/:classId/remove-student/:studentId",
  DELETE_CLASS: "/class/:classId",
  UPDATE_CLASS: "/class/:classId",
  GET_ALL_CLASSES: "/class/all",
  UPDATE_USER_CLASSES: "/class/update-user-classes/:userId",

  // lesson module
  CREATE_LESSON: "/lesson/create",
  TAKE_ATTENDANCE: "/lesson/:lessonId/take-attendance",
  GET_LESSONS_BY_CLASS: "/lesson/class/:id",

  // homework
  SUBMIT_HOMEWORK: "/homework/submit",
  GET_HOMEWORK_BY_LESSON: "/homework/lesson/:id",
  FREESTYLE_TO_IDEA: "/items/freestyleToIdea",
  FREELEARN_TO_IDEA: "/items/freeLearnToIdea",
  GRAMMAR_VOCABULARY_PRACTICE: "/items/grammarVocabularyPratice",
  CHAT_WITH_AI: "/items/chatWithAI",
  CHAT_WITH_AI_MULTI: "/items/chatWithAIMulti",
  ASPECT_EXPLANATION: "/items/aspect-explanation",

  GEN_VOCA_BY_BAND: "/voca-question/gen-voca-by-band",
  SAVE_VOCA_QUESTION: "/voca-question/upsert",
  GET_VOCA_QUESTION: "/voca-question/:questionId",

  PRACTICE_GET_MAIN_IDEA: "/practices/get-main-idea",
  PRACTICE_PRONUNCIATION_ANALYZE: "/practices/pronunciation-analyze",
  PRACTICE_PRONUNCIATION_HISTORY: "/practices/pronunciation-history",
  PRACTICE_PRONUNCIATION_STATS: "/practices/pronunciation-stats",
  PRACTICE_REACTION_SESSION: "/practices/reaction-session",
  PRACTICE_REACTION_SESSIONS: "/practices/reaction-sessions",

  DICTS_GET_RANDOM_WORDS: "/dicts/random",
  INSERT_TERMS_WORDBOOK: "/wordbooks/enter-terms/:wordbookId",
  GET_COMMUNITY_WORDBOOKS: "/wordbooks/community/get-all",

  // assignment
  CREATE_VOCA_ASSIGNMENT: "/voca-assignments",
  GET_VOCA_ASSIGNMENT: "/voca-assignments/get-one/:id",
  GET_VOCA_ASSIGNMENT_BY_CREATED: "/voca-assignments/created-by",
  GET_VOCA_ASSIGNMENT_BY_CLASS: "/voca-assignments/class/:id",
  SAVE_VOCA_SUBMISSION: "/voca-submissions/save",
  GET_LIST_VOCA_SUBMISSION_BY_ASSIGNMENT: "/voca-submissions/assignment/:id",
  GET_MY_SUBMISSION: "/voca-submissions/my-submission/:id",

  // Speaking assignments
  CREATE_ASSIGNMENT: "/assignments",
  GET_ASSIGNMENTS_BY_TEACHER: "/assignments/by-teacher",
  GET_ASSIGNMENTS_BY_CLASS: "/assignments/class/:classId",
  GET_ASSIGNMENT_BY_ID: "/assignments/:id",
  UPDATE_ASSIGNMENT: "/assignments/:id",
  SET_ASSIGNMENT_STATUS: "/assignments/:id/status",
  DELETE_ASSIGNMENT: "/assignments/:id",
  GET_ASSIGNMENT_SUBMISSIONS: "/assignments/:id/submissions",
  GET_CLASS_OVERVIEW: "/assignments/class/:classId/overview",
  GET_TEACHER_OVERVIEW: "/assignments/teacher/overview",
  GET_CLASS_STUDENT_DETAIL: "/assignments/class/:classId/student/:studentId",
  GET_CLASS_STUDENT_TASK_DETAIL: "/assignments/class/:classId/student/:studentId/task/:taskId",
  GET_MY_ASSIGNMENTS: "/assignments/student/my-assignments",
  GET_ASSIGNMENT_STUDENT_VIEW: "/assignments/:id/student-view",
  SCORE_ASSIGNMENT_TASK: "/assignments/:id/tasks/:taskId/score",
  SCORE_ASSIGNMENT_WRITING_TASK: "/assignments/:id/tasks/:taskId/score-writing",
  SUBMIT_ASSIGNMENT: "/assignments/:id/submit",
  // Submission feedback (teacher ↔ student)
  ADD_SUBMISSION_FEEDBACK: "/assignments/:submissionId/feedbacks",
  GET_SUBMISSION_FEEDBACKS: "/assignments/:submissionId/feedbacks",
  GET_MY_ASSIGNMENT_FEEDBACKS: "/assignments/:assignmentId/my-feedbacks",
  DELETE_SUBMISSION_FEEDBACK: "/assignments/feedbacks/:feedbackId",
  RESET_STUDENT_TASK: "/assignments/class/:classId/student/:studentId/task/:taskId/reset-redo",
  RESET_STUDENT_ASSIGNMENT: "/assignments/class/:classId/student/:studentId/assignment/:assignmentId/reset-redo",

  // course
  GET_LIST_COURSES: "/courses",
  GET_ONE_COURSE: "/courses/:id",
  CREATE_ONE_COURSE: "/courses",
  UPDATE_ONE_COURSE: "/courses/:id",
  DELETE_ONE_COURSE: "/courses/:id",

  // update-vocabs
  UPDATE_VOCABS: "/vocabs/update-vocabs",
  SUGGEST_ANSWER_FROM_IDEA: "/answers/suggest-answer-from-idea",
  GENERATE_MULTI_BAND_ANSWERS: "/answers/generate-multi-band-answers",
  TRANSLATE_IMPROVE: "/answers/translate-improve",
  UPGRADE_BAND: "/answers/upgrade-band",
  GRAMMAR_CHECK: "/answers/grammar-check",

  // timeline
  GET_TIMELINES: "/timeline",
  GET_TIMELINE_BY_ID: "/timeline/:id",
  CREATE_TIMELINE: "/timeline",
  UPDATE_TIMELINE: "/timeline/:id",
  DELETE_TIMELINE: "/timeline/:id",
  GET_TIMELINE_BY_QUESTION: "/timeline/question/:questionId",
  GET_TIMELINE_QUESTIONS: "/timeline/questions",

  // Timeline Group endpoints
  GET_TIMELINE_GROUPS: "/timeline/group",
  GET_TIMELINE_GROUP_BY_ID: "/timeline/group",
  CREATE_TIMELINE_GROUP: "/timeline/group",
  UPDATE_TIMELINE_GROUP: "/timeline/group",
  DELETE_TIMELINE_GROUP: "/timeline/group",
  GET_TIMELINE_GROUP_BY_QUESTION: "/timeline/group/question",

  // Timeline Library endpoints
  GET_TIMELINE_LIBRARIES: "/timeline-library",
  GET_TIMELINE_LIBRARY_BY_ID: "/timeline-library/:id",
  CREATE_TIMELINE_LIBRARY: "/timeline-library",
  UPDATE_TIMELINE_LIBRARY: "/timeline-library/:id",
  DELETE_TIMELINE_LIBRARY: "/timeline-library/:id",
  GET_TIMELINE_LIBRARIES_BY_QUESTION: "/timeline-library/question/:questionId",
  GET_TIMELINE_GROUPS_FOR_QUESTION: "/timeline-library/question/:questionId/timeline-groups",
  DUPLICATE_TIMELINE_TO_LIBRARY: "/timeline-library/duplicate/:timelineGroupId/:timelineIndex",
  INCREMENT_TIMELINE_USAGE: "/timeline-library/:id/increment-usage",

  // Payment endpoints
  CREATE_PAYMENT: "/payment/create",
  CREATE_TOPUP: "/payment/create-topup",
  GET_PAYMENT_STATUS: "/payment/status/:referenceCode",
  GET_TRANSACTION_HISTORY: "/payment/history",
  GET_ALL_TRANSACTIONS: "/payment/all-transactions",
  GET_WEBHOOK_LOGS: "/payment/webhook-logs",
  MANUAL_ACTIVATE_TRANSACTION: "/payment/manual-activate/:id",
  ADMIN_TOPUP: "/payment/admin-topup",

  // Package endpoints
  GET_PACKAGES: "/package",
  GET_ONE_PACKAGE: "/package/:id",
  CREATE_PACKAGE: "/package",
  UPDATE_PACKAGE: "/package/:id",
  DELETE_PACKAGE: "/package/:id",
  GET_USER_STATS: "/user-stats/:userId",

  // Question Types
  GET_QUESTION_TYPES: "/question-types",
  ONE_QUESTION_TYPE: "/question-types/:id",
  LINK_QUESTION_TO_TYPE: "/question-types/link",
  UNLINK_QUESTION_FROM_TYPE: "/question-types/unlink",
  GET_LINKED_QUESTIONS: "/question-types/:id/questions",
  GET_TIMELINE_STRUCTURES: "/timeline-structures",
  GET_ASPECT_STRUCTURES: "/aspect-structures",
  // Forecast
  GET_FORECASTS: "/forecast",
  CREATE_FORECAST: "/forecast",
  ONE_FORECAST: "/forecast/:id",
  GET_GROUPED_FORECASTS: "/forecast/grouped",
  // TTS Proxy (server-side, no CORS)
  ITEMS_TTS: "/items/tts",
  QUESTION_SUGGESTIONS: "/question-suggestions",

  // Notifications
  GET_NOTIFICATIONS: "/notifications",
  GET_NOTIFICATIONS_UNREAD_COUNT: "/notifications/unread-count",
  MARK_NOTIFICATION_READ: "/notifications/:id/read",
  MARK_ALL_NOTIFICATIONS_READ: "/notifications/read-all",
  DELETE_NOTIFICATION: "/notifications/:id",

  // Email Templates
  GET_EMAIL_TEMPLATES: "/email-templates",
  GET_ONE_EMAIL_TEMPLATE: "/email-templates/:id",
  CREATE_EMAIL_TEMPLATE: "/email-templates",
  UPDATE_EMAIL_TEMPLATE: "/email-templates/:id",
  DELETE_EMAIL_TEMPLATE: "/email-templates/:id",
  GET_EMAIL_LOGS: "/email-templates/logs",

  // Groups
  GET_GROUPS: "/groups",
  GET_ONE_GROUP: "/groups/:id",
  CREATE_GROUP: "/groups",
  UPDATE_GROUP: "/groups/:id",
  DELETE_GROUP: "/groups/:id",

  // IELTS Exams
  GET_IELTS_EXAMS: "/ielts-exams",
  GENERATE_IELTS_EXAM: "/ielts-exams/generate",
  PUBLISH_IELTS_EXAM: "/ielts-exams/:id/publish",
  DELETE_IELTS_EXAM: "/ielts-exams/:id",
  GET_IELTS_EXAM_BY_ID: "/ielts-exams/:id",
  SUBMIT_IELTS_EXAM: "/ielts-exams/:id/submit",
  GET_IELTS_SUBMISSION: "/ielts-exams/submissions/:id",
  UPDATE_IELTS_ANNOTATIONS: "/ielts-exams/submissions/:id/annotations",
  GET_MY_IELTS_SUBMISSIONS: "/ielts-exams/my/submissions",
  GET_CMS_IELTS_SUBMISSIONS: "/ielts-exams/cms/submissions",

  // Supplementary Exercises & Flashcards
  SUPPLEMENTARY_EXERCISES: "/supplementary-exercises",
  SUPPLEMENTARY_EXERCISE_BY_ID: "/supplementary-exercises/:id",
  SUPPLEMENTARY_EXERCISE_SUBMIT: "/supplementary-exercises/:id/submit",
  SUPPLEMENTARY_EXERCISES_CMS_LIST: "/supplementary-exercises/cms/list",
  SUPPLEMENTARY_EXERCISES_PUBLISHED: "/supplementary-exercises/published",
  SUPPLEMENTARY_EXERCISE_SAVE_RESULT: "/supplementary-exercises/:id/save-result",
  SUPPLEMENTARY_EXERCISES_MY_RESULTS: "/supplementary-exercises/my-results",
  CAMBRIDGE_FLASHCARDS: "/cambridge-flashcards",

  // Common Structures (Từ vựng chung)
  COMMON_STRUCTURES: "/common-structures",

  // Prompt Templates (Quản lý Prompt AI)
  PROMPT_TEMPLATES: "/prompt-templates",

  // User Reports / Bug Ticket System
  CREATE_USER_REPORT: "/user-reports",
  GET_MY_USER_REPORTS: "/user-reports/my-reports",
  GET_USER_REPORTS: "/user-reports",
  GET_USER_REPORT_BY_ID: "/user-reports/:id",
  UPDATE_USER_REPORT_STATUS: "/user-reports/:id/status",
};

// /my-submission

export const getApiUrl = (endpoint: string, params?: any, isParamId: boolean = false): string => {
  let path = endpoint;
  if (params) {
    if (isParamId) {
      forEach(params, (value, key) => {
        const replace = `:${key}`;
        if (path.indexOf(replace) !== -1) {
          const re = new RegExp(replace, "g");
          path = path.replace(re, value?.toString() ?? "");
        }
      });
    } else {
      let hasPathParam = false;
      const queryParams: Record<string, any> = {};
      forEach(params, (value, key) => {
        const replace = `:${key}`;
        if (path.indexOf(replace) !== -1) {
          hasPathParam = true;
          const re = new RegExp(replace, "g");
          path = path.replace(re, value?.toString() ?? "");
        } else if (value !== undefined && value !== null) {
          queryParams[key] = value;
        }
      });

      if (!hasPathParam) {
        path = path + "?" + new URLSearchParams(params).toString();
      } else if (Object.keys(queryParams).length > 0) {
        path = path + "?" + new URLSearchParams(queryParams).toString();
      }
    }
  }
  const baseApi = import.meta.env.VITE_API_BASE || configs.apiBaseDev;
  return baseApi + path;
};

export const parseParamUrl = (endpoint: string, params?: any, query?: any): string => {
  let path = endpoint;
  if (params) {
    forEach(params, (value, key) => {
      const replace = `:${key}`;
      if (path.indexOf(replace) !== -1) {
        const re = new RegExp(replace, "g");
        path = path.replace(re, value.toString());
      }
    });
  }
  if (query) {
    path = path + "?" + new URLSearchParams(query).toString();
  }
  return path;
};
